var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardOSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71429 6V3.42857H6V6H1.71429ZM1.71429 7.71429H6V10.2857H1.71429V7.71429ZM7.71429 10.2857V7.71429H12V10.2857H7.71429ZM12 6H7.71429V3.42857H12V6ZM1.71429 0C0.76875 0 0 0.76875 0 1.71429V10.2857C0 11.2312 0.76875 12 1.71429 12H12C12.9455 12 13.7143 11.2312 13.7143 10.2857V1.71429C13.7143 0.76875 12.9455 0 12 0H1.71429Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardOSm);
export default __webpack_public_path__ + "static/media/clipboard-o-sm.f4a3b89892601b4e02d8232c67b58d4a.svg";
export { ForwardRef as ReactComponent };